// extracted by mini-css-extract-plugin
export default {"container":"style_container__05L1+","titleSection":"style_titleSection__++IoO"};